import { ProductCategoriesManager } from '@/components/specifications/ProductCategoriesManager';

export default function AdminProductCategoriesPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <ProductCategoriesManager />
    </div>
  );
}
